import apiClient from '@/shared/api/client'
import type {
  LockStatusResponse, EditRequest, EditApprovalRule,
} from '@/shared/types/editLock'

export const editLockApi = {
  getStatus: async (entity_name: string, entity_id: string): Promise<LockStatusResponse> => {
    const res = await apiClient.get<LockStatusResponse>('/edit-lock/status', {
      params: { entity_name, entity_id },
    })
    return res.data
  },

  finalize: async (entity_name: string, entity_id: string, plant_id?: string): Promise<LockStatusResponse> => {
    const res = await apiClient.post<LockStatusResponse>('/edit-lock/finalize', {
      entity_name, entity_id, plant_id,
    })
    return res.data
  },

  completeEdit: async (entity_name: string, entity_id: string): Promise<LockStatusResponse> => {
    const res = await apiClient.post<LockStatusResponse>('/edit-lock/complete-edit', {
      entity_name, entity_id,
    })
    return res.data
  },

  requestEdit: async (data: {
    entity_name: string; entity_id: string; reason: string; plant_id?: string
  }): Promise<EditRequest> => {
    const res = await apiClient.post<EditRequest>('/edit-lock/edit-requests', data)
    return res.data
  },

  listPending: async (): Promise<EditRequest[]> => {
    const res = await apiClient.get<EditRequest[]>('/edit-lock/edit-requests/pending')
    return res.data
  },

  listMine: async (status?: string): Promise<EditRequest[]> => {
    const res = await apiClient.get<EditRequest[]>('/edit-lock/edit-requests/mine', {
      params: status ? { status } : undefined,
    })
    return res.data
  },

  actOnRequest: async (id: string, status: 'APPROVED' | 'REJECTED', remarks?: string): Promise<EditRequest> => {
    const res = await apiClient.post<EditRequest>(`/edit-lock/edit-requests/${id}/action`, {
      status, remarks,
    })
    return res.data
  },

  listRules: async (): Promise<EditApprovalRule[]> => {
    const res = await apiClient.get<EditApprovalRule[]>('/edit-lock/rules')
    return res.data
  },

  createRule: async (data: {
    entity_name: string; approver_role_id: string; plant_id?: string
  }): Promise<EditApprovalRule> => {
    const res = await apiClient.post<EditApprovalRule>('/edit-lock/rules', data)
    return res.data
  },

  deactivateRule: async (id: string): Promise<void> => {
    await apiClient.delete(`/edit-lock/rules/${id}`)
  },
}
